import { ref } from 'vue'

// Singleton — estado compartido por toda la app
const deferredPrompt = ref(null)
const puedeInstalar = ref(false)
const yaInstalada = ref(false)
const esIOS = ref(false)
const bannerDescartado = ref(false)

const STORAGE_KEY = 'vedent-install-banner-descartado'

function detectarIOS() {
  const ua = navigator.userAgent || ''
  return /iPad|iPhone|iPod/.test(ua) || (ua.includes('Mac') && navigator.maxTouchPoints > 1)
}

function detectarInstalada() {
  return window.matchMedia('(display-mode: standalone)').matches || navigator.standalone === true
}

// Llamar una sola vez desde App.vue
export function inicializarInstallPrompt() {
  esIOS.value = detectarIOS()
  yaInstalada.value = detectarInstalada()
  bannerDescartado.value = localStorage.getItem(STORAGE_KEY) === 'true'

  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault()
    deferredPrompt.value = e
    puedeInstalar.value = true
  })

  window.addEventListener('appinstalled', () => {
    deferredPrompt.value = null
    puedeInstalar.value = false
    yaInstalada.value = true
    bannerDescartado.value = true
  })
}

export function useInstallPrompt() {
  async function instalar() {
    if (!deferredPrompt.value) return false
    deferredPrompt.value.prompt()
    const { outcome } = await deferredPrompt.value.userChoice
    deferredPrompt.value = null
    puedeInstalar.value = false
    return outcome === 'accepted'
  }

  function descartarBanner() {
    bannerDescartado.value = true
    localStorage.setItem(STORAGE_KEY, 'true')
  }

  function mostrarBanner() {
    if (yaInstalada.value || bannerDescartado.value) return false
    return puedeInstalar.value || esIOS.value
  }

  return {
    puedeInstalar,
    yaInstalada,
    esIOS,
    bannerDescartado,
    instalar,
    descartarBanner,
    mostrarBanner,
  }
}
